import { createAction, props } from '@ngrx/store';
import {DashboardItem} from '../../dashboard.model';

export const checkDashboardStart = createAction('LANDINGPAGE::CHECK_DASHBOARD_START');
export const checkDashboardSucceeded = createAction(
    'LANDINGPAGE::CHECK_DASHBOARD_SUCCEEDED'
);
export const checkDashboardFailed = createAction('LANDINGPAGE::CHECK_DASHBOARD_FAILED', props<{ error: Error }>());
